import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3371">
      <Navbar data-id="element-3372" />
      <main data-id="element-3373">
        <ConsularAffairs data-id="element-3374" />
      </main>
      <Footer data-id="element-3375" />
      <FeedbackPopup data-id="element-3376" />
    </div>;
}